<template>
  <el-card class="box-card">
    <div slot="header" class="box-head clearfix">
      <span class="card-head">Facebook Insights</span>
      <span class="pull-right">
        <el-select v-model="facebookPage" size="mini">
          <el-option
            v-for="page in facebookPages"
            :key="page.id"
            :label="page.handle"
            :value="page.id"
          />
        </el-select>
      </span>
      <span class="pull-right">
        <el-radio-group v-model="period" size="mini">
          <el-radio-button label="day" />
          <el-radio-button label="week" />
          <el-radio-button label="month" />
        </el-radio-group>
      </span>
    </div>
    <div class="card-content">
      <div v-if="isLoading" class="insights-container">
        <loader message="Loading Insights" shadow="none" />
      </div>
      <div v-else-if="hasData" class="insights-container">
        <InsightsOverviewItem
          v-for="(value, key) in overviewData"
          class="insight-item"
          :data="value"
          :period="period"
          :key="key"
          @onNavigate="handleItemNavigate(key)"
        />
      </div>
      <div v-else class="placeholder">
        <content-placeholder
          :count="1"
          :text-only="true"
          :text-value="facebookPage ? 'No data' : 'No page connected'"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
import Loader from '@/components/common/Loader';
import ContentPlaceholder from '@/components/common/ContentPlaceholder';
import InsightsOverviewItem from './InsightsOverviewItem';

export default {
  name: 'InsightsOverview',

  components: {
    InsightsOverviewItem,
    Loader,
    ContentPlaceholder,
  },

  props: {
    overviewData: {
      type: Object,
      default: () => ({}),
    },
    facebookPages: {
      type: Array,
      default: () => [],
    },
    selectedPage: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    period: 'week',
    metricRoutes: {
      page_views: 'pageViews',
      page_likes: 'pageViews',
      reach: 'pageViews',
      post_engagements: 'pageViews',
    },
  }),

  computed: {
    facebookPage: {
      get() {
        return this.selectedPage;
      },
      set(value) {
        this.$emit('onSelectedPageChange', value);
      },
    },
    hasData() {
      return this.overviewData && Object.keys(this.overviewData).length > 0;
    },
  },

  methods: {
    handleItemNavigate(key) {
      this.$router.push(`social/facebook/${this.metricRoutes[key]}`);
    },
  },

  watch: {
    period(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('onFacebookPeriodChanged', newVal);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$my-text-color: #676a6c;

.insights-container {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.insight-item {
  min-width: 250px;
  max-width: 300px;
  height: 200px;
  margin: 10px;
}

.card-head {
  font-size: 1.3em;
}

.clearfix:after {
  clear: both;
}

.box-card {
  color: $my-text-color;
}

.box-head {
  height: 1.5em;
}

.card-content {
  min-height: 350px;
  margin: 0px;
}

.posts-placeholder {
  text-align: center;
  color: lighten($my-text-color, 25);
  font-size: 1.2em;
}
</style>


// WEBPACK FOOTER //
// InsightsOverview.vue?49eb3cac